import css from './textStatisticCard.module.css'
import { CSSProperties, PropsWithChildren, ReactNode } from 'react'
import FormField from '../../Forms/FormField'
import Skeleton from '@/shared/Loaders/Skeleton'

interface IProps {
  title: string | ReactNode
  style?: CSSProperties
}

interface IPropsWithSkeleton extends IProps {
  loading: boolean
  width: string
  height: string
}

const TextStatisticCard = (props: PropsWithChildren<IProps | IPropsWithSkeleton>) => {
  return (
    <Skeleton
      height={'height' in props ? props.height : ''}
      width={'width' in props ? props.width : undefined}
      loading={'loading' in props ? props.loading : false}
    >
      <div className={css.wrapper} style={props.style}>
        <FormField label={props.title} type="description" fullWidth={true} style={{ height: '100%' }}>
          {props.children}
        </FormField>
      </div>
    </Skeleton>
  )
}

export default TextStatisticCard
